import { useState } from "react";
import GetIcon from "../../../../../utils/Icon";
import Button from "../../../../../Core/Button/Button";
import ConfigureColumns from "../Components/ConfigureColumns";
import { parseERPNextError } from "../../../../../utils/parseERPNextError";
import { usePostPartSalesDataApiMutation } from "../../../../../store/api/salesinvoiceAuricApi";
import Input from "../../../../../Core/Fields/Floating/Input";

const PartSalesModal = ({ show, error, onClose, generalDetails, partSalesState }) => {
  const [scanserialno, setscanserialno] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [getPartSalesData] = usePostPartSalesDataApiMutation();
  
  const scanSerialNo = async () => {
    if (!generalDetails.customer) {
      error.seterrorType("Error");
      error.seterrorMessage("Customer is required");
      error.setisErrorVisible(true);
      return;
    }
    try {
      const formData = new FormData();
      formData.append("serial_no", scanserialno);
      const response = await getPartSalesData(formData).unwrap();
      console.log("check part sales invoice is here", response);
      partSalesState.setpartSalesState(response.message);
      setExpanded(true);
    } catch (err) {
      console.error("❌ Error saving invoice:", err);
      error.seterrorType("Error");
      error.seterrorMessage(parseERPNextError(err));
      error.setisErrorVisible(true);
    }
  };

  if (!show) return null;

  // Access the data from partSalesState
  const data = partSalesState?.partSalesState || {};
  const items = data?.items || [];
  const metalData = data?.custom_metal || [];
  const diamondData = data?.custom_diamond || [];
  const stoneData = data?.custom_stone || [];
  const labourData = data?.custom_labour || [];

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className={`modal-dialog modal-dialog-centered ${expanded ? "modal-xl" : "modal-md"}`}>
        <div className="modal-content rounded-3 shadow-sm border-0">
          <div className="modal-header py-2 px-3" style={{ borderBottom: "0px" }}>
            <h5 className="modal-title fw-semibold" style={{ fontSize: "18px" }}>
              Part Sale Details
            </h5>
            <button type="button" className="btn-close" style={{ fontSize: "14px" }}
              onClick={() => { setExpanded(false); onClose(); }}>
            </button>
          </div>

          <div className="modal-body px-4 pb-3">
            {/* Scan Serial Input */}
            <div className="mb-3 d-flex align-items-center gap-2">
              <input
                type="text"
                className="form-control"
                value={scanserialno}
                onChange={(e) => setscanserialno(e.target.value)}
                style={{ fontSize: "12px", height: "32px", padding: "5px 8px", width: "50%" }}
                placeholder="Scan Serial No."
              />
              {!expanded && (
                <Button 
                  className="custom-btn-00989"
                  style={{ gap: '2px', height: '30px' }}
                  onClick={() => scanSerialNo()}>
                  Fetch
                </Button>
              )}
            </div>

            {/* Info Banner */}
            
            {/* {expanded && items.length > 0 && (
              <div className="alert alert-info py-2 mb-3" style={{ fontSize: "12px" }}>
                <strong>Serial No:</strong> {items[0]?.serial_no || "N/A"} | 
                <strong className="ms-2">Item Code:</strong> {items[0]?.item_code || "N/A"} | 
                <strong className="ms-2">Gross Wt:</strong> {items[0]?.custom_gross_wt || "0.00"}g
              </div>
            )} */}

            {/* Expanded View */}
            {expanded && (
              <>
                {/* Item Table */}
                <TableSection
                  title="Item"
                  data={items}
                  initialColumns={[
                    { key: "item_code", name: "Item Code", selected: true },
                    { key: "custom_gross_wt", name: "Gross Wt", selected: true },
                    { key: "custom_formula", name: "Formula", selected: true },
                    { key: "custom_calculated_price", name: "Calculated Price", selected: true },
                    { key: "custom_mrp", name: "MRP", selected: true },
                    { key: "rate", name: "Rate", selected: true },
                    { key: "amount", name: "Amount", selected: true },
                  ]}
                  renderCell={(item, colKey) => {
                    switch(colKey) {
                      case "custom_gross_wt":
                        return `${item[colKey] || "0.00"}g`;
                      case "custom_calculated_price":
                      case "custom_mrp":
                      case "rate":
                      case "amount":
                        return `₹ ${item[colKey] || "0.00"}`;
                      default:
                        return item[colKey] || "N/A";
                    }
                  }}
                />

                {/* Metal Table */}
                <TableSection
                  title="Metal"
                  data={metalData}
                  initialColumns={[
                    { key: "item_code", name: "Item Code", selected: true },
                    { key: "metal_gross_wt", name: "Metal Gross Wt", selected: true },
                    { key: "custom_metal_net_wt", name: "Metal Net Wt", selected: true },
                    { key: "custom_purity", name: "Purity", selected: true },
                    { key: "custom_today_metal_rate", name: "Today Metal Rate", selected: true },
                    { key: "custom_metal_rate", name: "Metal Rate", selected: true },
                    { key: "custom_metal_rateamt", name: "Metal Amount", selected: true },
                  ]}
                  renderCell={(item, colKey) => {
                    if (colKey.includes("_wt")) {
                      return `${item[colKey] || "0.00"}g`;
                    }
                    if (colKey.includes("rate") || colKey.includes("amount") || colKey.includes("amt")) {
                      return `₹ ${item[colKey] || "0.00"}`;
                    }
                    return item[colKey] || "N/A";
                  }}
                />

                {/* Diamond Table */}
                <TableSection
                  title="Diamond"
                  data={diamondData}
                  initialColumns={[
                    { key: "item_code", name: "Item Code", selected: true },
                    { key: "custom_vendor_design_no", name: "Vendor Design No", selected: true },
                    { key: "custom_diamond_weight", name: "Diamond Wt", selected: true },
                    { key: "custom_diamond_weightct", name: "Diamond Wt (ct)", selected: true },
                    { key: "diamond_rate", name: "Diamond Rate", selected: true },
                    { key: "custom_diamond_rateamt", name: "Diamond Amount", selected: true },
                  ]}
                  renderCell={(item, colKey) => {
                    if (colKey.includes("weight")) {
                      return `${item[colKey] || "0.00"}g`;
                    }
                    if (colKey.includes("ct")) {
                      return `${item[colKey] || "0.00"}ct`;
                    }
                    if (colKey.includes("rate") || colKey.includes("amount") || colKey.includes("amt")) {
                      return `₹ ${item[colKey] || "0.00"}`;
                    }
                    return item[colKey] || "N/A";
                  }}
                />

                {/* Stone Table */}
                <TableSection
                  title="Stone"
                  data={stoneData}
                  initialColumns={[
                    { key: "item_code", name: "Item Code", selected: true },
                    { key: "custom_vendor_design_no", name: "Vendor Design No", selected: true },
                    { key: "custom_stone_weight", name: "Stone Wt", selected: true },
                    { key: "custom_stone_weight_ct", name: "Stone Wt (ct)", selected: true },
                    { key: "stone_rate", name: "Stone Rate", selected: true },
                    { key: "custom__stone_rateamt", name: "Stone Amount", selected: true },
                  ]}
                  renderCell={(item, colKey) => {
                    if (colKey.includes("weight")) {
                      return `${item[colKey] || "0.00"}g`;
                    }
                    if (colKey.includes("ct")) {
                      return `${item[colKey] || "0.00"}ct`;
                    }
                    if (colKey.includes("rate") || colKey.includes("amount") || colKey.includes("amt")) {
                      return `₹ ${item[colKey] || "0.00"}`;
                    }
                    return item[colKey] || "N/A";
                  }}
                />

                {/* Labour Table */}
                <TableSection
                  title="Labour"
                  data={labourData}
                  initialColumns={[
                    { key: "item_code", name: "Item Code", selected: true },
                    { key: "custom_vendor_design_no", name: "Vendor Design No", selected: true },
                    { key: "labour_wt", name: "Labour Wt", selected: true },
                    { key: "labour_rate", name: "Labour Rate", selected: true },
                    { key: "custom_labour_rateamt", name: "Labour Amount", selected: true },
                  ]}
                  renderCell={(item, colKey) => {
                    if (colKey.includes("wt")) {
                      return `${item[colKey] || "0.00"}g`;
                    }
                    if (colKey.includes("rate") || colKey.includes("amount") || colKey.includes("amt")) {
                      return `₹ ${item[colKey] || "0.00"}`;
                    }
                    return item[colKey] || "N/A";
                  }}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// ---------- Updated TableSection Component ----------
const TableSection = ({ title, data = [], initialColumns, renderCell }) => {
  const [columns, setColumns] = useState(initialColumns);
  const [expandedRow, setExpandedRow] = useState(null);
  const [showConfig, setShowConfig] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const visibleColumns = columns.filter((c) => c.selected);

  const handleSaveColumns = (updated) => {
    setColumns(updated);
    setShowConfig(false);
  };

  const toggleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(data.map((_, index) => index));
    } else {
      setSelectedRows([]);
    }
  };

  const toggleSelectRow = (index) => {
    setSelectedRows(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <div className="mb-3">
      <p className="fw-semibold mb-1" style={{ fontSize: "14px" }}>{title}</p>

      <table className="table table-bordered align-middle mb-2" style={{ fontSize: "12px" }}>
        <thead className="tableHead1">
          <tr>
            <th style={{ width: "3%" }}>
              <input 
                type="checkbox" 
                onChange={toggleSelectAll}
                checked={selectedRows.length === data.length && data.length > 0}
              />
            </th>
            {visibleColumns.map((col) => (
              <th key={col.key}>{col.name}</th>
            ))}
            <th style={{ width: "5%", textAlign: "center" }}>
              <span onClick={() => setShowConfig(true)} style={{ cursor: "pointer" }}>
                <GetIcon iconName="IoSettingsOutline" size={14} />
              </span>
            </th>
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <>
              <tr key={index}>
                <td>
                  <input 
                    type="checkbox" 
                    checked={selectedRows.includes(index)}
                    onChange={() => toggleSelectRow(index)}
                  />
                </td>
                {visibleColumns.map((col) => (
                  <td key={`${col.key}-${index}`} style={{ textAlign: "center" }}>
                    {renderCell ? renderCell(item, col.key) : (item[col.key] || "N/A")}
                  </td>
                ))}
              <td style={{ textAlign: "center" }}>
                  <span 
                    style={{ cursor: "pointer" }}
                    onClick={() => setExpandedRow(expandedRow === index ? null : index)}
                  >
                    <GetIcon iconName="MdOutlineEdit" size={14} />
                  </span>
              </td>

              </tr>

              {expandedRow === index && (
  <tr>
    <td colSpan={visibleColumns.length + 2}>
      <ExpandedEditBox item={item} />
    </td>
  </tr>
)}
</>
            ))
          ) : (
            <tr>
              <td colSpan={visibleColumns.length + 2} style={{ textAlign: "center", color: "#999" }}>
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <Button className="Addrowdesign" iconName="FiPlus" iconSize={12}>
        Add Row
      </Button>

      {/* Configure Columns Modal */}
      <ConfigureColumns
        show={showConfig}
        title={title}
        onClose={() => setShowConfig(false)}
        onSave={handleSaveColumns}
        initialFields={columns}
      />
    </div>
  );
};

export default PartSalesModal;










const ExpandedEditBox = ({ item }) => {
  return (
    <div className="p-3 border rounded" style={{ background: "#FDF8ED" }}>
      
      {/* First Row */}
      <div className="row mt-2">
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Item Code"
            style={{ height: "30px", textAlign:'left' }}
            value={item.item_code || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Item Name"
            style={{ height: "30px", textAlign:'left' }}
            value={item.item_name || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Serial No"
            style={{ height: "30px", textAlign:'left' }}
            value={item.serial_no || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Vendor Item No"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_vendor_design_no || ''}
            readOnly
          />
        </div>
      </div>

      {/* Second Row */}
      <div className="row mt-2">
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Item Gross Wt"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_gross_wt || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Old Serial No"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_old_serial_no || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Purchase Metal Rate"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_metal_rate || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Wastage Pure Gold"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_wastage_puregold || ''}
            readOnly
          />
        </div>
      </div>

      {/* Third Row */}
      <div className="row mt-2">
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Metal"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_metal || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Metal Weight"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_metal_net_wt || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Metal Purity"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_purity || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Metal Pure Gold"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_pure_gold || ''}
            readOnly
          />
        </div>
      </div>

      {/* Fourth Row */}
      <div className="row mt-2">
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Formula"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_formula || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Formula MRP"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_calculated_price}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Net MRP"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_net_mrp || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Tag Price"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_tag_price}
            readOnly
          />
        </div>
      </div>

      {/* Fifth Row - Diamond/Stone Weights */}
      <div className="row mt-2">
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Diamond Wt(ct)"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_diamond_weightct || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Diamond Wt(gm)"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_diamond_weight || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Stone Wt(ct)"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_stone_weight_ct || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Stone Wt(gm)"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_stone_weight || ''}
            readOnly
          />
        </div>
      </div>

      {/* Sixth Row - Amounts */}
      <div className="row mt-2">
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Metal Amount"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_metal_rateamt || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Diamond Amount"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_diamond_rateamt || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Stone Amount"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom__stone_rateamt || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Labour Amount"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_labour_rateamt || ''}
            readOnly
          />
        </div>
      </div>

      {/* Seventh Row - Final Values */}
      <div className="row mt-2">
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Vendor Invoice Value"
            style={{ height: "30px", textAlign:'left' }}
            value={item.amount}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Total Rate"
            style={{ height: "30px", textAlign:'left' }}
            value={item.rate}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Total Amount"
            style={{ height: "30px", textAlign:'left' }}
            value={item.amount}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          {/* Empty column for alignment */}
        </div>
      </div>

      {/* Additional Fields */}
      <div className="row mt-2">
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="MRP"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_mrp}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Category"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_category || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          <Input
            label="Design"
            style={{ height: "30px", textAlign:'left' }}
            value={item.custom_design || ''}
            readOnly
          />
        </div>
        <div className="col-md-3" style={{textAlign:'left'}}>
          {/* Empty column for alignment */}
        </div>
      </div>
    </div>
  );
};
